import React,{useState} from "react";
import { useNavigate } from "react-router-dom";
import { deactivateAccount } from "../../api/services/authService";
import { useWorkspace } from "../../integrationQA/context/WorkspaceContext";
import "./ForgotPassword.css";
import "./UserDeactivation.css";
function UserDeactivation(){
  const navigate = useNavigate();
  const { clearSession } = useWorkspace();
  const [text,setText]=useState("");
  const [status,setStatus]=useState("");
  const [busy,setBusy]=useState(false);
  const submit=async e=>{
    e.preventDefault();
    if(text.trim().toUpperCase()!=="DEACTIVATE")return setStatus("Please type DEACTIVATE correctly.");
    setBusy(true);
    try{
      await deactivateAccount(text.trim());
      setStatus("Account deactivated successfully.");
      setTimeout(()=>{clearSession();navigate("/login",{replace:true,state:{deactivated:true}});},1200);
    }catch(err){
      setStatus(err.message||"Unable to deactivate the account.");
      setBusy(false);
    }
  };
  return <div className="simple-page"><div className="simple-card"><h1>Deactivate Account</h1><p>Type DEACTIVATE to confirm.</p><form onSubmit={submit}><label>Confirmation</label><input value={text} onChange={e=>setText(e.target.value)} placeholder="Type DEACTIVATE"/>{status&&<div className={status.includes("successfully")?"info":"error"}>{status}</div>}<button disabled={busy}>{busy?"Deactivating…":"Deactivate Account"}</button></form><button className="secondary" onClick={()=>navigate("/dashboard")}>Cancel</button></div></div>;
}
export default UserDeactivation;
